import map from 'lodash/map';
import pickBy from 'lodash/pickBy';
import pick from 'lodash/pick';
import flatten from 'lodash/flatten';
import axios from 'axios';
// import { getColumns } from 'CouponUtils';// ! Disabled until fixing the CouponUtils and jest conflict.

import {
  SUPER_SYSTEM_COUPONS_REQUEST,
  SUPER_SYSTEM_COUPONS_SUCCESS,
  SUPER_SYSTEM_COUPONS_FAILURE,
  SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST,
  SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS,
  SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE,
  SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST,
  SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS,
  SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE,
  SUPER_SYSTEM_VALIDATE_REQUEST,
  SUPER_SYSTEM_VALIDATE_SUCCESS,
  SUPER_SYSTEM_VALIDATE_FAILURE,
  SUPER_SYSTEM_PLAYED_COUPONS_REQUEST,
  SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS,
  SUPER_SYSTEM_PLAYED_COUPONS_FAILURE
} from 'Store/constants';

import errorMessage from './errorMessage';
import { openModal } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;
export const MAXIMUM_COUPON_COUNT = 20000;

export const getSuperSystemCoupons = () => async (dispatch, getState) => {
  dispatch({
    type: SUPER_SYSTEM_BETSLIP_COUPONS_REQUEST
  });
  try {
    // Aktif betslip datası alınıyor
    const activeBetSlip = getState().betSlip;

    // Aktif betslip datası kullanılarak coupon-utils'e gönderilecek data modeli oluşturuluyor
    const selections = activeBetSlip.coupon.bets.map(bet => {
      return {
        eventCode: bet.eventId,
        minSelectionCount: bet.mbs,
        key: bet.eventId + bet.marketId,
        odd: +bet.odds,
        _isBanker: bet.banker
      };
    });

    const bankerCount = activeBetSlip.coupon.bets.filter(bet => bet.banker).length;

    // Active betslip üzderinden seçilen sistem bilgisi alınılıyor
    const selectedSystems = activeBetSlip.coupon.system;

    // oluşturulan model coupon-utils üzerinden 'getColumns' methodu ile parçalnıyor
    const superCoupons = selectedSystems || selections;//getColumns(selections, selectedSystems); // ! Update this line when CouponUtils conflict is fixed.

    // coupon utils üzerinden dönen data ile sayfa datası oluşturuluyor
    const superSystemPageData = pickBy(superCoupons.columnGroups, coupon => coupon.columnCount > 0);

    // super sistem kuponlara
    const superSystemCouponData = map(superSystemPageData, card => pick(card, 'columns').columns);

    // Oluşturulan Object 1 kırılım kısaltılıyor
    const flattenSuperSystemCoupons = flatten(superSystemCouponData);

    const reducedNonBankerCoupons = flattenSuperSystemCoupons.filter(coupon => {
      const couponsWithBankers = coupon.selections.filter(event => event._isBanker);
      return bankerCount ? bankerCount === couponsWithBankers.length : true;
    });

    const superSystemBetSlipBets = reducedNonBankerCoupons.map(coupons => {
      const bets = coupons.selections.map(bet => {
        return activeBetSlip.coupon.bets.find(b => b.eventId === bet.eventCode);
      });

      return {
        key: coupons.id,
        channel: 1,
        couponCount: 1,
        multiplier: 3,
        system: [bets.length || 1],
        acceptHigherOdds: activeBetSlip.coupon.acceptHigherOdds,
        acceptLowerOdds: activeBetSlip.coupon.acceptLowerOdds,
        bets: bets
      };
    });

    dispatch(_verifySuperSystemBetSlip(superSystemBetSlipBets));

    // verificationa gönderilmeden önce oluşturulan kuponlar reducera gönderiliyor
    dispatch({
      type: SUPER_SYSTEM_BETSLIP_COUPONS_SUCCESS,
      payload: superSystemBetSlipBets
    });


  } catch (error) {
    _superSystemFlowFailure(dispatch, error);
    dispatch({
      type: SUPER_SYSTEM_BETSLIP_COUPONS_FAILURE,
      payload: (error.response && error.response.data) || errorMessage
    });
  }
};

export const updateSuperSystemCalculations = (options = {}) => async (dispatch, getState) => {
  dispatch({
    type: SUPER_SYSTEM_VALIDATE_REQUEST
  });

  try {
    const superSystemCoupons = getState().superSystem.coupons.data;
    const { multiplier, multipleCouponCount } = options;

    const updatedCouponsData = superSystemCoupons.map(data => {
      if (options.hasOwnProperty('multiplier')) {
        return {
          ...data,
          multiplier: +multiplier,
          couponCost: +multiplier,
          expectedWinAmount: +data.totalOdd * +multiplier
        };
      }

      if (options.hasOwnProperty('multipleCouponCount')) {
        return {
          ...data,
          couponCount: +multipleCouponCount
        };
      }

      return { ...data };
    });

    _superSystemFlowSuccess({ dispatch, data: updatedCouponsData });

  } catch (error) {
    dispatch({
      type: SUPER_SYSTEM_VALIDATE_FAILURE,
      payload: (error.response.data.errors[0].message || errorMessage)
    });
  }
};

export const updateSuperSystemCouponCalculation = (options = {}) => async (dispatch, getState) => {
  _superSystemFlowRequest(dispatch);

  try {

    const superSystemCoupons = getState().superSystem.coupons.data;
    const { key, multiplier } = options;

    const findSelectedCoupon = find(superSystemCoupons, coupon => coupon.key === key);

    const updatedCouponData = {
      ...findSelectedCoupon,
      multiplier: +multiplier,
      couponCost: +multiplier,
      expectedWinAmount: +findSelectedCoupon.totalOdd * +multiplier
    };

    const changedSuperSystemCoupons = map(superSystemCoupons, coupon => {
      if (coupon.key === updatedCouponData.key) {
        coupon = updatedCouponData;
      }
      return { ...coupon };
    });

    _superSystemFlowSuccess({ dispatch, data: changedSuperSystemCoupons });

  } catch (error) {
    _superSystemFlowFailure({ dispatch, error });
  }
};

export const submitSuperSystemCoupons = () => async (dispatch, getState) => {

  const balanceInfo = getState().auth.data.balance;
  const multipleCouponPrice = getState().superSystem.betSlip.summary.data.multipleCouponPrice;

  if (multipleCouponPrice > balanceInfo) {
    return dispatch(openModal('superSystemInsufficientFundsModal'));
  }

  const payloadData = getState().superSystem.coupons.data;
  const postData = {
    superSystemCoupons: [
      ...payloadData
    ]
  };

  dispatch({
    type: SUPER_SYSTEM_PLAYED_COUPONS_REQUEST,
  });

  try {
    const res = await axios.post(API_GATEWAY + '/supersystem/play', postData);
    const responseData = res.data.superSystemCoupons;

    dispatch({
      type: SUPER_SYSTEM_PLAYED_COUPONS_SUCCESS,
      payload: responseData
    });

    _showSuperSystemInfoModals(responseData, dispatch);

  } catch (error) {
    dispatch(openModal('superSystemPartiallyFailureModal'));
    dispatch({
      type: SUPER_SYSTEM_PLAYED_COUPONS_FAILURE,
      // payload: (error.response.data.errors[0].message || errorMessage) // TODO: henuz bır hata standartımız olmadıgından hata alıyor
    });
    dispatch({
      type: SUPER_SYSTEM_VALIDATE_FAILURE,
      // payload: (error.response.data.errors[0].message || errorMessage) //TODO: henuz bır hata standartımız olmadıgından hata alıyor
    });
  }
};

const _showSuperSystemInfoModals = (data, dispatch) => {

  const hasAnyOddOrLimitChangedArray = data.filter(rd => rd['hasAnyOddOrLimitChanged']);
  const isAllPlayedArray = data.filter(rd =>  rd['isAllPlayed'] );
  const isPartiallyPlayedArray = data.filter(rd => rd['isPartiallyPlayed']);

  if (hasAnyOddOrLimitChangedArray.length) {
    return dispatch(openModal('oddOrLimitChanged', { response: hasAnyOddOrLimitChangedArray } ));
  }

  if (!isAllPlayedArray.length && !isPartiallyPlayedArray.length) {
    dispatch(openModal('playCouponFailureModal'));
  } else if (isPartiallyPlayedArray.length || isAllPlayedArray.length < data.length) {
    dispatch(openModal('superSystemPartiallyFailureModal', { response: data } ));
  } else {
    dispatch(openModal('superSystemSuccessModal'));
  }

};

const _superSystemFlowRequest = dispatch => {

  dispatch({
    type: SUPER_SYSTEM_COUPONS_REQUEST
  });

  dispatch({
    type: SUPER_SYSTEM_BETSLIP_SUMMARY_REQUEST
  });

};

const _superSystemFlowSuccess = ({ dispatch, data }) => {
  // coupon-utils kullanılarak oluşturulan kuponlar reducera yollanıyor
  dispatch({
    type: SUPER_SYSTEM_COUPONS_SUCCESS,
    payload: data
  });

  // kuponların verificataion'dan dönmüş halleri üzerinden reducera gönderiliyor
  const validatedCoupons = _reCalculateSuperSystemCoupons(data);
  dispatch({
    type: SUPER_SYSTEM_VALIDATE_SUCCESS,
    payload: validatedCoupons
  });

  // super sistem betslip'te kullanılacak datalar reducera gönderiliyor
  const betSlipInfo = _calculateBetSlipData(validatedCoupons);
  dispatch({
    type: SUPER_SYSTEM_BETSLIP_SUMMARY_SUCCESS,
    payload: {
      ...betSlipInfo,
      acceptHigherOdds: true,
      acceptLowerOdds: true,
    }
  });
};

const _superSystemFlowFailure = ({ dispatch, error }) => {
  dispatch({
    type: SUPER_SYSTEM_COUPONS_FAILURE,
    payload: (error.response && error.response.data) || errorMessage
  });

  dispatch({
    type: SUPER_SYSTEM_BETSLIP_SUMMARY_FAILURE,
    payload: (error.response && error.response.data) || errorMessage
  });
};

const _verifySuperSystemBetSlip = options => async dispatch => {
  const requestData = {
    superSystemCoupons: [
      ...options
    ]
  };
  _superSystemFlowRequest(dispatch);

  try {
    const res = await axios.post(API_GATEWAY + '/supersystem/verify', requestData);
    _superSystemFlowSuccess({ dispatch, data: res.data.superSystemCoupons });
  } catch (error) {
    _superSystemFlowFailure({ dispatch, error });
  }
};

const _reCalculateSuperSystemCoupons = data => {
  let groups = {};
  let totalAmount = 0;
  let couponPrice = 0;
  let multipleCouponCount = 0;
  let multipleCouponPrice = 0;
  let multipleTotalAmount = 0;

  for (let i = 0; i < data.length; i++) {
    let systemGroups = data[i].system[0];
    if (!groups[systemGroups]) {
      groups[systemGroups] = [];
    }
    groups[systemGroups].push(data[i]);
  }

  data = [];
  for (let system in groups) {
    if (groups.hasOwnProperty(system)) {
      groups[system].map(item => {
        totalAmount += item.expectedWinAmount;
        couponPrice += item.couponCost;
        multipleCouponCount = item.couponCount;
        multipleCouponPrice = multipleCouponCount * couponPrice;
        multipleTotalAmount += multipleCouponCount * item.expectedWinAmount;
      });

      data.push({
        system: system,
        data: groups[system],
        totalAmount: +totalAmount,
        couponPrice: +couponPrice,
        multipleCouponCount: multipleCouponCount,
        multipleCouponPrice: +multipleCouponPrice,
        multipleTotalAmount: +multipleTotalAmount
      });
      totalAmount = 0;
      multipleTotalAmount = 0;
      couponPrice = 0;
      multipleCouponCount = 0;
      multipleCouponPrice = 0;
    }
  }

  return data;
};

const _calculateBetSlipData = data => {

  let totalAmount = 0;
  let couponPrice = 0;
  let multipleCouponCount = 1;
  let multipleCouponPrice = 3;
  let multipleTotalAmount = 0;
  let totalCoupons = 0;
  let totalCouponCount = 0;

  for (let item of data) {
    totalAmount += +item.totalAmount;
    couponPrice += +item.couponPrice;
    multipleCouponCount = item.multipleCouponCount;
    multipleCouponPrice = multipleCouponCount * couponPrice;
    multipleTotalAmount = multipleCouponCount * totalAmount;
    totalCoupons += item.data.length;
    totalCouponCount += item.data.length * item.multipleCouponCount;
  }
  return {
    totalAmount,
    couponPrice,
    multipleCouponCount,
    multipleCouponPrice,
    multipleTotalAmount,
    totalCoupons,
    totalCouponCount
  };
};
